export enum Authority {
  PLAY_FOR_FREE = 'PLAY_FOR_FREE',
  EDIT_PRODUCT_OWNER = 'EDIT_PRODUCT_OWNER',
  REQUEST_TOUR_REVIEW = 'REQUEST_TOUR_REVIEW'
}

export function hasAuthority(authorities: string[], authority: Authority) {
  return authorities.includes(authority);
}
